import Draggable from 'gsap/umd/Draggable';
import {TweenMax} from 'gsap';
import {HelperBlockAdapter} from './HelperBlock';
import data from '../../../../data/basic.json';

const sizesUtils = require('../../viscomjs/utils/SizesUtils');
const HelperBlock = new HelperBlockAdapter();

let dragcont;
dragcont;
const setDragblock = drgbl => {
    dragcont = drgbl;
};

const canvasDimentions = {
    x: 2698,
    y: 1614
};

let pointIndex = 0;

export class DragControllerAdapter {
    constructor() {
        this._canvasContainer = document.querySelector('.canvas-container');
        this._pointsContainer = document.querySelector('.points-container');
        this._canvas = this._canvasContainer.querySelector('#canvas');
        this._points = [...document.querySelectorAll('.point')];
        this._mapAnimationContainer = this._canvasContainer.querySelector('#animation_container');
        this._mapDraggable = {};
        this._dragblock;
        this._canvasCoords = {
            x: 0,
            y: 0
        };
        this._clickCoords = {
            x: 0,
            y: 0
        };
        this._grabCoords = {
            x: 0,
            y: 0
        };
        this._delta = {
            x: 0,
            y: 0
        };
    }

    fixCanvas(x, y) {
        this._canvasCoords.x = x;
        this._canvasCoords.y = y;
    }

    gotoNextPoint() {
        const nextPoint = +pointIndex < 10 ? +pointIndex : 0;
        setTimeout(() => {
            this.moveMap(-this._calcPoint(nextPoint + 1).x, -this._calcPoint(nextPoint + 1).y);
        }, 200);
    }

    scaleMap(index) {
        pointIndex = index;
        const pointsPosition = {
            x: (canvasDimentions.x / 100) * data.points[index].x - sizesUtils.winWidth() * 0.275,
            y: (canvasDimentions.y / 100) * data.points[index].y - sizesUtils.winHeight() * 0.5
        };
        this.moveMap(-pointsPosition.x, -pointsPosition.y, 0.8);
        TweenMax.to(this._pointsContainer, 0.5, {
            scale: 1.2
        });
        TweenMax.to(this._canvas, 0.5, {
            scale: 1.2
        });
    }

    _calcPoint(index) {
        index = +index < 10 ? +index : 0;
        const pointsPosition = {
            x: (canvasDimentions.x / 100) * data.points[index].x - sizesUtils.winWidth() * 0.275,
            y: (canvasDimentions.y / 100) * data.points[index].y - sizesUtils.winHeight() * 0.5
        };
        pointsPosition.x = pointsPosition.x < 0 ? 0 : pointsPosition.x;
        pointsPosition.y = pointsPosition.y < 0 ? 0 : pointsPosition.y;
        pointsPosition.x = pointsPosition.x > 2698 - sizesUtils.winWidth() ? 2698 - sizesUtils.winWidth() : pointsPosition.x;
        pointsPosition.y = pointsPosition.y > 1614 - sizesUtils.winHeight() ? 1614 - sizesUtils.winHeight() : pointsPosition.y;

        return pointsPosition;
    }

    unscaleMap() {
        pointIndex = +pointIndex < 10 ? +pointIndex : 0;
        this.moveMap(-this._calcPoint(pointIndex).x, -this._calcPoint(pointIndex).y);
        TweenMax.to(this._canvas, 0.5, {
            scale: 1
        });
        TweenMax.to(this._pointsContainer, 0.5, {
            scale: 1
        });
    }

    moveMap(x, y, delay = 0) {
        TweenMax.to(this._mapAnimationContainer, 0.6, {
            x: x,
            y: y,
            delay: delay
        });
    }

    init() {
        this.moveMap(-this._calcPoint(0).x, -this._calcPoint(0).y, 0.8);

        const drgbl = Draggable.create('#animation_container', {
            type: 'x,y',
            bounds: document.getElementById('canvas-container-inner'),
            onClick: function() {},
            onDragEnd: () => {
                TweenMax.to(this._canvas, 0.5, {
                    scale: 1
                });
                TweenMax.to(this._pointsContainer, 0.5, {
                    scale: 1
                });
                HelperBlock.disable();
            },
            onDrag: () => {
                TweenMax.to(this._canvas, 0.5, {
                    scale: 0.96
                });
                TweenMax.to(this._pointsContainer, 0.5, {
                    scale: 0.96
                });
            }
        });
        setDragblock(drgbl);
        this._dragblock = drgbl;
    }

    enable() {
        dragcont[0].enable();
    }

    disable() {
        dragcont[0].disable();
    }
}
